import type React from 'react';

import { translationKey } from '@change-corgi/core/i18n';

import { useSharingTools } from '../../../../hooks/useSharingTools';
import { SharingToolsCardWrapper } from '../../../SharingToolsCardWrapper';
import { PosterPreview } from '../PosterPreview';

export const QRPosterCard: React.FC = () => {
	const { data, actions } = useSharingTools();

	return (
		<SharingToolsCardWrapper
			Preview={<PosterPreview posterTemplate={data.posters.template} />}
			titleKey={translationKey('corgi.petition.starter_dashboard_v2.sharing_tools.qr_poster.title')}
			descriptionKey={translationKey('corgi.petition.starter_dashboard_v2.sharing_tools.qr_poster.description')}
			primaryActionTextKey={translationKey(
				'corgi.petition.starter_dashboard_v2.sharing_tools.qr_poster.primary_action_text',
			)}
			primaryActionOnClick={actions.openFlyerDownloadModal}
		/>
	);
};
